var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewsCategoryBase',{attrs:{"title":{ 'zh-CN': '本站动态', 'en-US': 'Company News' },"route-path":"/news/company","category":"company"}})
}
var staticRenderFns = []

export { render, staticRenderFns }